import { twMerge } from "tailwind-merge";

import { IconProps } from "~/common/utils";

export const ArrowRepeatIcon = ({ className, ...props }: IconProps) => {
  return (
    <svg
      className={twMerge("size-5", className)}
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M7.3125 3.75H5.25C3.59315 3.75 2.25 5.09315 2.25 6.75V11.25C2.25 12.9069 3.59315 14.25 5.25 14.25H12.75C14.4069 14.25 15.75 12.9069 15.75 11.25V6.75C15.75 5.09315 14.4069 3.75 12.75 3.75H11.9531M6 6L7.71967 4.28033C8.01256 3.98744 8.01256 3.51256 7.71967 3.21967L6 1.5"
        stroke="currentColor"
        strokeWidth="1.67"
        strokeLinecap="round"
      />
    </svg>
  );
};
